// @ts-nocheck
import {
    GetProductVariantsApiParameter,
    getVariants,
    VariantsResult,
} from "@store/Framework/Services/ProductServiceV2";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type GetProductVariantsParameter = {
    productVariantsApiParameter: GetProductVariantsApiParameter;
};

type Parameter = HasOnError<string> & HasOnSuccess<VariantsResult> & GetProductVariantsParameter;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetProductVariantsApiParameter, VariantsResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        productId: props.parameter.productVariantsApiParameter.productId,
        pageSize: 500,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getVariants(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
        props.parameter.onSuccess?.(props.apiResult);
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi];

const loadVariants = createHandlerChainRunner(chain, "LoadVariants");
export default loadVariants;
